import React from 'react';
import LoginShell from './LoginShell';
import SocialAuthButtons from '../SocialAuthButtons';

// Standard login — Google SSO inside the shared split-screen shell.
const LoginStitch = () => (
  <LoginShell>
    <form>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <SocialAuthButtons />
      </div>
    </form>
  </LoginShell>
);

export default LoginStitch;
